module.exports = __webpack_public_path__ + "static/media/Diners_Club.95484985.svg";